import {UmpireImage} from '../umpire-image';
import {UmpireLinkTypeEnum} from '../umpire-link-type';
import {UmpirePageType} from '../umpire-page-type';
import {UmpirePublicationCategory} from '../umpire-publication-category';

export interface UmpirePageTypeLink {
  id: string;
  attributes: Omit<UmpirePageType, 'image' | 'publication_categories'>;
  relationships: {
    image: Partial<UmpireImage>;
    publication_categories: Partial<UmpirePublicationCategory>;
  };
  type: UmpireLinkTypeEnum.PAGE_TYPE;
}
